"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NibbySadGraphicIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const get_size_1 = require("../get-size");
const use_mesh_selector_1 = require("../../mesh/use-mesh-selector");
const NibbySadGraphicIcon = _a => {
  var {
      size = "md",
      fill = "currentColor"
    } = _a,
    props = __rest(_a, ["size", "fill"]);
  const fillColor = (0, use_mesh_selector_1.useMeshSelector)(fill);
  const sizeValue = (0, get_size_1.getSize)(size);
  return (0, jsx_runtime_1.jsxs)("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: sizeValue,
    height: sizeValue,
    fill: "none",
    viewBox: "0 0 32 33"
  }, props, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M6.128 26.433H2.724A2.723 2.723 0 0 1 0 23.71V3.285A2.723 2.723 0 0 1 2.724.562h26.553A2.723 2.723 0 0 1 32 3.285V23.71a2.723 2.723 0 0 1-2.723 2.723H15.206l-7.989 5.992a.68.68 0 0 1-1.089-.545zm8.442-1.226a.68.68 0 0 1 .409-.136h14.298c.752 0 1.361-.609 1.361-1.361V3.285c0-.752-.61-1.361-1.361-1.361H2.724c-.753 0-1.362.609-1.362 1.361V23.71c0 .752.61 1.361 1.362 1.361h4.085a.68.68 0 0 1 .68.681v4.766z",
      clipRule: "evenodd"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M6.7 15.19a3.724 3.724 0 0 0 6.685-.042.68.68 0 1 0-1.226-.593 2.364 2.364 0 0 1-4.24.027.68.68 0 1 0-1.22.608m12.25-.021a3.724 3.724 0 0 0 6.685 0 .681.681 0 0 0-1.222-.6 2.362 2.362 0 0 1-4.241 0 .68.68 0 1 0-1.222.6m2.942 5.564a8.51 8.51 0 0 0-11.461-.175.684.684 0 0 0-.058.961.68.68 0 0 0 .962.06 7.145 7.145 0 0 1 9.626.147.686.686 0 0 0 .963-.03.68.68 0 0 0-.032-.963",
      clipRule: "evenodd"
    })]
  }));
};
exports.NibbySadGraphicIcon = NibbySadGraphicIcon;